'use strict';

import React from 'react';

const failures = props => (
  <div role="alert" className='d-flex bg-white flex-column align-items-center justify-content-around py-5'>
    {props.errorMessage
      ?
        <p className="pb-4">
          {props.errorMessage}
        </p>
      :
        <p className="pb-4">
          <strong>{props.numberOfFailures}</strong> photo{props.numberOfFailures == 1 ? '' : 's' } failed to upload.
        </p>
    }
    <div className="d-flex flex-wrap">
      {
        props.shouldRetry &&
        <button
          className="btn btn-primary add-to-prints px-3 mx-3"
          onClick={() => props.onRetry()}
        >
          Retry
        </button>
      }
      <button
        className="btn btn-secondary btn-ignore px-3 mx-3"
        onClick={() => props.onIgnore()}
      >
        {props.shouldRetry ? 'Ignore' : 'Close'}
      </button>
    </div>
  </div>
);

export default failures;